<template>
    <modal
        :id="id"
        :centered="true"
        :title="title"
        :show="noticeModal.show"
        :close="noticeModal.close"
        :closeable="noticeModal.closeable"
        :tighter-close-button="true"
        size="modal-lg"
        @modal-close="hideModal"
    >
        <div class="modal-body">
            <p class="mb-0" v-html="text"></p>
        </div>
        <div class="modal-footer justify-content-center">
            <template v-if="type === 'default'">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="$emit('close')"
                    v-html="$t('generic.close')"
                ></button>
            </template>
            <template v-else-if="type === 'confirm'">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="$emit('decline')"
                    v-html="$t('generic.no')"
                ></button>
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click="$emit('confirm')"
                    v-html="$t('generic.yes')"
                ></button>
            </template>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'notice-popup',
        },
        type: {
            type: String,
            required: false,
            default: 'default',
            validator: (val) => ['default', 'confirm'].includes(val),
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        text: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            noticeModal: {
                show: false,
                close: false,
                closeable: true,
            },
        };
    },

    methods: {
        /**
         * Handle the visibility update of the modal.
         *
         * @returns {this}
         */
        showModal() {
            this.noticeModal.show = true;
            this.noticeModal.close = false;

            return this;
        },

        hideModal() {
            this.noticeModal.show = false;
            this.noticeModal.close = true;

            return this;
        },
    },

    mounted() {
        this.hideModal();
    },
};
</script>
